module.exports = __webpack_public_path__ + "static/media/stats.aa2cbd8f.png";